interface StatusStampProps {
  status: string;
  className?: string;
}

const formatStatusLabel = (status: string) =>
  status.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());

const statusClasses = (status: string) =>
  status === 'planned'
    ? 'border-blue-500 bg-blue-50/90 text-blue-700'
    : 'border-red-500 bg-red-50/90 text-red-600';

const StatusStamp: React.FC<StatusStampProps> = ({
  status,
  className = '',
}) => (
  <div
    className={`pointer-events-none absolute left-4 top-4 rotate-[-12deg] rounded-md border-2 px-3 py-1 text-xs font-bold uppercase tracking-[0.2em] shadow-sm ${statusClasses(status)} ${className}`}
  >
    {formatStatusLabel(status)}
  </div>
);

export default StatusStamp;
